import type { LocaleMessageBundle } from '../../types'

export const voucherMessages: LocaleMessageBundle = {
  vi: {
    'voucher.search': 'Tìm kiếm',
    'voucher.title': 'Mã giảm giá',
    'voucher.add': 'Thêm voucher',
    'voucher.edit': 'Cập nhật voucher',
    'voucher.dialog.createSubtitle': 'Thiết lập mã, giá trị giảm và điều kiện sử dụng voucher',
    'voucher.dialog.editSubtitle': 'Cập nhật thông tin và phạm vi áp dụng voucher',
    'voucher.membershipTier.section': 'Đối tượng hạng thành viên',
    'voucher.membershipTier.scope': 'Phạm vi hạng thành viên',
    'voucher.membershipTier.select': 'Chọn hạng thành viên',
    'voucher.membershipTier.all': 'Tất cả hạng',
    'voucher.membershipTier.selected': 'Hạng đã chọn',
    'voucher.applyErrors.membershipTierRequired':
      'Voucher {code} chỉ áp dụng cho thành viên hạng {tiers}. Vui lòng chọn khách hàng phù hợp.',
    'voucher.applyErrors.membershipTierNotEligible':
      'Voucher {code} chỉ áp dụng cho thành viên hạng {tiers}.',
    'voucher.sections.information': 'Thông tin voucher',
    'voucher.sections.discount': 'Giá trị giảm',
    'voucher.sections.validity': 'Hiệu lực và điều kiện',
    'voucher.sections.limits': 'Phạm vi và giới hạn',
    'voucher.code': 'Mã voucher',
    'voucher.name': 'Tên voucher',
    'voucher.description': 'Mô tả',
    'voucher.usageProgress': 'Đã dùng / Tổng số',
    'voucher.applyErrors.notFound': 'Không tìm thấy voucher {code}.',
    'voucher.applyErrors.inactive': 'Voucher {code} hiện không hoạt động.',
    'voucher.applyErrors.notStarted':
      'Voucher {code} chưa đến thời gian sử dụng (Bắt đầu: {date}).',
    'voucher.applyErrors.expired': 'Voucher {code} đã hết hạn sử dụng (Hạn dùng: {date}).',
    'voucher.applyErrors.branch': 'Voucher {code} không áp dụng cho chi nhánh hiện tại.',
    'voucher.applyErrors.minimumOrder':
      'Voucher {code} chỉ áp dụng cho đơn hàng từ {minimum}đ (Giá trị đơn hiện tại: {current}đ).',
    'voucher.applyErrors.tableScope': 'Voucher {code} chỉ áp dụng cho bán hàng theo bàn.',
    'voucher.applyErrors.totalLimit': 'Voucher {code} đã hết lượt sử dụng.',
    'voucher.applyErrors.customerRequired': 'Voucher {code} yêu cầu chọn khách hàng.',
    'voucher.applyErrors.memberOnly':
      'Voucher {code} chỉ áp dụng cho khách hàng thành viên/đã đăng ký thông tin.',
    'voucher.applyErrors.memberRemoved':
      'Đã loại voucher {code} vì đơn hàng không còn khách hàng thành viên.',
    'voucher.applyErrors.customerLimit': 'Khách hàng đã hết lượt sử dụng voucher {code}.',
    'voucher.applyErrors.staffLimit': 'Nhân viên đã hết lượt sử dụng voucher {code}.',
    'voucher.applyErrors.duplicate': 'Voucher {code} đã được áp dụng.',
    'voucher.discountType': 'Kiểu giảm',
    'voucher.discountValue': 'Giá trị giảm',
    'voucher.maxDiscount': 'Giảm tối đa',
    'voucher.conditionType': 'Điều kiện áp dụng',
    'voucher.condition.unconditional': 'Không điều kiện',
    'voucher.condition.minimum_order': 'Có điều kiện',
    'voucher.minOrder': 'Giá trị hóa đơn tối thiểu',
    'voucher.scope': 'Giảm giá cho',
    'voucher.scope.table': 'Tiền bàn',
    'voucher.scope.products': 'Sản phẩm',
    'voucher.scope.all': 'Tất cả',
    'voucher.type.percent': 'Phần trăm',
    'voucher.type.fixed': 'Số tiền',
    'voucher.validFrom': 'Bắt đầu',
    'voucher.validUntil': 'Kết thúc',
    'voucher.status': 'Trạng thái',
    'voucher.status.draft': 'Nháp',
    'voucher.status.active': 'Hoạt động',
    'voucher.status.paused': 'Tạm ngưng',
    'voucher.status.archived': 'Đã lưu trữ',
    'voucher.totalLimit': 'Tổng lượt sử dụng',
    'voucher.customerLimit': 'Lượt/khách hàng',
    'voucher.staffLimit': 'Lượt/nhân viên',
    'voucher.branchScope': 'Phạm vi chi nhánh',
    'voucher.branch.all': 'Tất cả chi nhánh',
    'voucher.branch.selected': 'Chi nhánh được chọn',
    'voucher.branches': 'Chi nhánh',
    'voucher.activate': 'Kích hoạt',
    'voucher.pause': 'Tạm ngưng',
    'voucher.archive': 'Lưu trữ',
    'voucher.archiveConfirm': 'Lưu trữ voucher "{name}"?',
    'voucher.noExpiry': 'Không giới hạn',
    'voucher.unlimited': 'Không giới hạn',
    'voucher.viewDetail': 'Xem chi tiết',
    'voucher.errors.saveFailed': 'Không thể lưu voucher',
  },
  en: {
    'voucher.search': 'Search',
    'voucher.title': 'Vouchers',
    'voucher.add': 'Add voucher',
    'voucher.edit': 'Update voucher',
    'voucher.dialog.createSubtitle': 'Configure the voucher code, discount and usage conditions',
    'voucher.dialog.editSubtitle': 'Update voucher information and application scope',
    'voucher.membershipTier.section': 'Membership tier audience',
    'voucher.membershipTier.scope': 'Membership tier scope',
    'voucher.membershipTier.select': 'Select membership tiers',
    'voucher.membershipTier.all': 'All tiers',
    'voucher.membershipTier.selected': 'Selected tiers',
    'voucher.applyErrors.membershipTierRequired':
      'Voucher {code} is only available to {tiers} members. Please select an eligible customer.',
    'voucher.applyErrors.membershipTierNotEligible':
      'Voucher {code} is only available to {tiers} members.',
    'voucher.sections.information': 'Voucher information',
    'voucher.sections.discount': 'Discount value',
    'voucher.sections.validity': 'Validity and conditions',
    'voucher.sections.limits': 'Scope and limits',
    'voucher.code': 'Voucher code',
    'voucher.name': 'Voucher name',
    'voucher.description': 'Description',
    'voucher.usageProgress': 'Used / Total',
    'voucher.applyErrors.notFound': 'Voucher {code} was not found.',
    'voucher.applyErrors.inactive': 'Voucher {code} is not active.',
    'voucher.applyErrors.notStarted': 'Voucher {code} is not valid yet (Starts: {date}).',
    'voucher.applyErrors.expired': 'Voucher {code} has expired (Expiry: {date}).',
    'voucher.applyErrors.branch': 'Voucher {code} is not valid at the current branch.',
    'voucher.applyErrors.minimumOrder':
      'Voucher {code} requires an order of at least {minimum} (Current order: {current}).',
    'voucher.applyErrors.tableScope': 'Voucher {code} only applies to table sales.',
    'voucher.applyErrors.totalLimit': 'Voucher {code} has reached its usage limit.',
    'voucher.applyErrors.customerRequired': 'Voucher {code} requires a selected customer.',
    'voucher.applyErrors.memberOnly': 'Voucher {code} is only available to registered customers.',
    'voucher.applyErrors.memberRemoved':
      'Voucher {code} was removed because the sale no longer has a registered customer.',
    'voucher.applyErrors.customerLimit':
      'The customer has reached the usage limit for voucher {code}.',
    'voucher.applyErrors.staffLimit':
      'The staff member has reached the usage limit for voucher {code}.',
    'voucher.applyErrors.duplicate': 'Voucher {code} is already applied.',
    'voucher.discountType': 'Discount type',
    'voucher.discountValue': 'Discount value',
    'voucher.maxDiscount': 'Maximum discount',
    'voucher.conditionType': 'Application condition',
    'voucher.condition.unconditional': 'No condition',
    'voucher.condition.minimum_order': 'Conditional',
    'voucher.minOrder': 'Minimum invoice amount',
    'voucher.scope': 'Discount scope',
    'voucher.scope.table': 'Table fee',
    'voucher.scope.products': 'Products',
    'voucher.scope.all': 'All',
    'voucher.type.percent': 'Percent',
    'voucher.type.fixed': 'Fixed amount',
    'voucher.validFrom': 'Starts at',
    'voucher.validUntil': 'Ends at',
    'voucher.status': 'Status',
    'voucher.status.draft': 'Draft',
    'voucher.status.active': 'Active',
    'voucher.status.paused': 'Paused',
    'voucher.status.archived': 'Archived',
    'voucher.totalLimit': 'Total usage limit',
    'voucher.customerLimit': 'Limit/customer',
    'voucher.staffLimit': 'Limit/staff',
    'voucher.branchScope': 'Branch scope',
    'voucher.branch.all': 'All branches',
    'voucher.branch.selected': 'Selected branches',
    'voucher.branches': 'Branches',
    'voucher.activate': 'Activate',
    'voucher.pause': 'Pause',
    'voucher.archive': 'Archive',
    'voucher.archiveConfirm': 'Archive voucher "{name}"?',
    'voucher.noExpiry': 'No expiry',
    'voucher.unlimited': 'Unlimited',
    'voucher.viewDetail': 'View details',
    'voucher.errors.saveFailed': 'Unable to save voucher',
  },
}
